<template>
  <Modal
    :title="
      isNew ? t('dashboard.todos.new.title') : t('dashboard.todos.edit.title')
    "
  >
    <ModalCloseButton :to="{ name: 'Dashboard' }" />

    <Field
      v-model="formData.title"
      v-validate="'required'"
      :error="errors.first('title')"
      :class="hasError('title')"
      fill
      type="text"
      :placeholder="t('dashboard.todos.new.title_placeholder')"
      name="title"
    />
    <VueEditorContainer>
      <QuillEditor
        v-model="formData.description"
        :toolbar="customToolbar"
        content-type="html"
      />
    </VueEditorContainer>

    <FormSelect v-model="formData.userId" fill style="margin-top: 50px">
      <option :key="0" value="">
        {{ formatUser(null) }}
      </option>
      <option v-for="user in users" :key="user.id" :value="user.id">
        {{ user.name }}
      </option>
    </FormSelect>

    <ModalSaveButton @click="$emit('submit', formData)">
      {{
        isNew ? t('dashboard.todos.new.save') : t('dashboard.todos.edit.save')
      }}
    </ModalSaveButton>
  </Modal>
</template>

<script>
import VueTypes from 'vue-types'
import { QuillEditor } from 'vue-quill-next'
import { cloneDeep } from 'lodash'
import { mapGetters, mapActions } from 'vuex'

import Modal from '@/components/Modal'
import ModalCloseButton from '@/components/ModalCloseButton'
import ModalSaveButton from '@/components/ModalSaveButton'
import Field from '@/components/Field'
import VueEditorContainer from '@/components/VueEditorContainer'
import FormSelect from '@/components/FormSelect'
import vueEditorToolbarConfig from '@/utils/vueEditorToolbarConfig'

export default {
  name: 'TodoForm',
  components: {
    Modal,
    ModalCloseButton,
    ModalSaveButton,
    Field,
    VueEditorContainer,
    FormSelect,
    QuillEditor,
  },
  emits: ['submit'],
  props: {
    todo: VueTypes.shape({
      id: String,
      title: String,
      description: String,
      userId: VueTypes.oneOfType([String, null]),
    }).loose,
    isSaving: VueTypes.bool.isRequired,
  },

  data() {
    return {
      formData: cloneDeep(this.todo),
      customToolbar: vueEditorToolbarConfig,
    }
  },
  computed: {
    ...mapGetters(['userOptions', 'users']),
    isNew() {
      return !this.todo.id
    },
  },

  mounted() {
    this.fetchOrganizationUsers()
  },

  methods: {
    ...mapActions(['fetchOrganizationUsers']),
    hasError(field) {
      let items = this.errors.items.map(item => item.field)

      if (items.includes(field)) {
        return 'Field--error'
      }
    },
  },
}
</script>
